import ListIcon from '@material-ui/icons/ViewList';

import BillItemHistoryList from './BillItemHistoryList';

export default {
    list: BillItemHistoryList,
    icon: ListIcon,
};
